(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('BankAccountService', BankAccountService)

    /** @ngInject */
    function BankAccountService(HttpService) {
        const BankAccountService = {
            getByUnitId,
            getByUnitEconomicGroup,
            postBankAccount,
            putBankAccount
        }

        return BankAccountService;

        function getByUnitId(companyId) {
            return HttpService.get(`/banks/accounts/by-company/${companyId}`);
        }

        function getByUnitEconomicGroup(economicGroupId) {
            return HttpService.get(`/banks/accounts/by-economic-group/${economicGroupId}`);
        }

        function postBankAccount(bankAccount) {
            return HttpService.post('/banks/accounts', bankAccount);
        }

        function putBankAccount(bankAccount, disableAccount) {
            return HttpService.put(`/banks/accounts/${disableAccount}`, bankAccount);
        }
    }
}());